module.exports = __webpack_public_path__ + "img/mp.mp22db1d8.svg";